import type { ModalStyles } from './types';

const autoCentre = ['xs', 'sm'];
const closeButtonSize = '32px';

const PREFIX = 'vsModal';

export const classes = {
  titleContainer: `${PREFIX}-titleContainer`,
  title: `${PREFIX}-title`,
  closeX: `${PREFIX}-closeX`,
  contentContainer: `${PREFIX}-contentContainer`,
  actions: `${PREFIX}-actions`,
};

export const customStyles = ({
  dividers,
  actions,
  title,
  size = 'xs',
  showCloseX = true,
  theme,
  fullScreen,
}: ModalStyles) => {
  const hasActions = !!actions;
  const hasTitle = !!title;
  const shouldAutoCenter = !hasTitle && typeof size === 'string' && autoCentre.includes(size);

  return {
    [`& .${classes.contentContainer}`]: {
      '&.MuiDialogContent-root': {
        paddingBottom: hasActions && !dividers ? theme.spacing(0.5) : theme.spacing(2.5),
        paddingTop: hasTitle && !dividers ? theme.spacing(0.5) : theme.spacing(2.5),
        textAlign: shouldAutoCenter ? 'center' : 'left',
      },
    },
    [`& .${classes.closeX}`]: {
      position: 'absolute',
      top: theme.spacing(1.5),
      right: theme.spacing(1.5),
      width: closeButtonSize,
      height: closeButtonSize,
      zIndex: 10,
    },
    [`& .${classes.titleContainer}`]: {
      borderBottom: dividers || fullScreen ? `1px solid ${theme.palette.grey[100]}` : 0,
      boxShadow: fullScreen ? theme.shadows[1] : 0,
    },
    [`& .${classes.title}`]: {
      marginRight: showCloseX ? `calc(${closeButtonSize} + ${theme.spacing(0.5)})` : 0,
    },
    [`& .${classes.actions}`]: {
      '&.MuiDialogActions-root': {
        justifyContent: shouldAutoCenter ? 'center' : 'flex-start',
        padding: theme.spacing(2, 3),
        borderTop: dividers ? `1px solid ${theme.palette.grey[100]}` : 0,
      },
    },
  };
};
